/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".columnFix[_ngcontent-%COMP%]{width:160px}\n/*# sourceMappingURL=maintenance.component.css.map*/"];
export { styles as styles };
